import React from 'react';
import PropTypes from 'prop-types';
import { ProgressCircular } from '@americanexpress/dls-react';

const Spinner = ({ label }) => (
  <div className="flex flex-justify-center">
    <ProgressCircular
      labelOverrides={{
        screenReaderLabel: label,
      }}
    />
  </div>
);

Spinner.propTypes = {
  label: PropTypes.string.isRequired,
};

export { Spinner as TestSpinner };

export default Spinner;
